import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

export const journeyDatePickerDialog = {
  maxHeight: '100%',
  maxWidth: rem(864),
}

export const journeyDatePickerFormRoot = css({
  display: 'flex',
  flexDirection: 'column',
})

export const controlsContainer = (theme: Theme, isInModal = false): SerializedStyles =>
  css({
    ...(!isInModal && {
      [theme.breakpoints.up('lg')]: {
        gap: theme.spacing(6),
        gridTemplateColumns: '1fr 1fr',
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6),
      },
    }),
    backgroundColor: theme.customPalette.background.default,
    display: 'grid',
    gap: theme.spacing(2),
    gridTemplateColumns: '1fr',
    padding: `${theme.spacing(2)} ${rem(10)}`,
  })

export const controlsRow = css({
  display: 'flex',
  justifyContent: 'space-between',
})

export const datePickerContainer = (theme: Theme): SerializedStyles =>
  css({
    backgroundColor: theme.customPalette.background.paper,
    flexGrow: 1,
    paddingTop: theme.spacing(2),
    [theme.breakpoints.up('lg')]: {
      height: 'auto',
    },
  })

export const controlInputDate = css({
  flexGrow: 1,
})

export const controlDropdown = (theme: Theme): SerializedStyles =>
  css({
    flexBasis: rem(92),
    flexShrink: 0,
    marginLeft: theme.spacing(2),
  })

export const buttonWrapper = (theme: Theme): SerializedStyles =>
  css({
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  })
